import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
  borderColor: string;
};
export const Diamond = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(11);
  let backgroundColor;
  let borderColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      borderColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = borderColor;
    $[3] = props;
  } else {
    backgroundColor = $[1];
    borderColor = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== backgroundColor || $[5] !== borderColor) {
    t1 = <path d="M10.9395 6.26758C11.5252 5.68199 12.4748 5.68199 13.0605 6.26758L17.7324 10.9395C18.318 11.5252 18.318 12.4748 17.7324 13.0605L13.0605 17.7324C12.4748 18.318 11.5252 18.318 10.9395 17.7324L6.26758 13.0605C5.68199 12.4748 5.68199 11.5252 6.26758 10.9395L10.9395 6.26758Z" fill={backgroundColor} stroke={borderColor} />;
    $[4] = backgroundColor;
    $[5] = borderColor;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}</svg>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});